import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';

// DREAMNEST BIR DETAILS
window.company_name = "Dreamnest Play Cafe";
window.company_address = "Cluster 6 Azuela High Street Vicente Hizon Sr. Buhangin Distict City Of Davao, Davao Del Sur";
window.company_vat_reg_tin = "VAT Reg TIN: 324388268-00001";
window.company_min = "MIN: 25092915005941738";
window.company_sn = "SN: HABSIF000097";
window.company_ptu_no = "PTU No: FP092025-132-0551101-00001";
window.issued_date = "Issue Date: 10/02/2025";

// MYT BIR DETAILS
window.myt_name = "MYT SoftDev Solutions, Inc.";
window.myt_address1 = "301 The Greenery, Pope John Paul II Avenue, Kasambagan";
window.myt_address2 = "Cebu City, Cebu";
window.myt_vat_reg_tin = "VAT Reg TIN: 497280919-000";
window.myt_acc_no = "Acc No: 0814972809192023071833";
window.myt_issued_date = "Issue Date: 08/14/2023 ";
// window.websocket_ip = 'ws://192.168.1.25:3000';
// window.websocket_ip = 'ws://192.168.0.168:3000';

// window.printer_name = "EPSON TM-T82X Receipt";
window.printer_name = "CASHIER";
window.printer_bar = "BAR";
window.printer_kitchen = "KITCHEN";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
